import React from "react";
import { Path } from "react-native-svg";

import { IconPathProps } from "../types";

const DoubleChevronLeft = ({ lineColor, strokeWidth }: IconPathProps) => (
  <Path
    d="M12 4.5L4.5 12L12 19.5M19.5 4.5L12 12L19.5 19.5"
    stroke={lineColor}
    strokeWidth={strokeWidth}
    strokeLinejoin="round"
  />
);

export default DoubleChevronLeft;
